export const RequiredMarker = () => <span className="text-red-500 mb-4 ml-[1px] text-lg">*</span>;
